export default __webpack_public_path__ + "static/media/Student_cert.8519456f.jpg";